export const locale ={
    "truss": {
        "ru": "Ферма",
        "en": "Truss",
        "de": "Binder"
    },
    "pile_foundation": {
        "ru": "Свайный фундамент",
        "en": "Pile foundation",
        "de": "Pfahlfundament"
    },
    "delivery": {
        "ru": "Доставка",
        "en": "Delivery",
        "de": "Lieferung"
    },
    "installation": {
        "ru": "Монтаж",
        "en": "Installation",
        "de": "Montage"
    },
    "gutter_system": {
        "ru": "Водосточная система",
        "en": "Gutter system",
        "de": "Dachrinnensystem"
    },
    "additional_services": {
        "ru": "Дополнительные услуги",
        "en": "Additional services",
        "de": "Zusätzliche Leistungen"
    },
    "delivery_address": {
        "ru": "Адрес доставки",
        "en": "Delivery address",
        "de": "Lieferadresse"
    },
    "length": {
        "ru": "Длина",
        "en": "Length",
        "de": "Länge"
    },
    "width": {
        "ru": "Ширина",
        "en": "Width",
        "de": "Breite"
    },
    "height": {
        "ru": "Высота",
        "en": "Height",
        "de": "Höhe"
    },
    "truss_pitch": {
        "ru": "Угол фермы",
        "en": "Truss pitch",
        "de": "Binderneigung"
    },
    "left_roof_overhang": {
        "ru": "Вынос крыши слева",
        "en": "Left roof overhang",
        "de": "Linker Dachüberstand"
    },
    "right_roof_overhang": {
        "ru": "Вынос крыши справа",
        "en": "Right roof overhang",
        "de": "Rechter Dachüberstand"
    },
    "front_roof_overhang": {
        "ru": "Вынос крыши спереди",
        "en": "Front roof overhang",
        "de": "Vorderer Dachüberstand"
    },
    "rear_roof_overhang": {
        "ru": "Вынос крыши сзади",
        "en": "Rear roof overhang",
        "de": "Hinterer Dachüberstand"
    },
    "calculating_structure": {
        "ru": "Расчёт конструкции...",
        "en": "Calculating structure...",
        "de": "Konstruktion wird berechnet..."
    },
    "save_configuration": {
        "ru": "Сохранить конфигурацию",
        "en": "Save configuration",
        "de": "Konfiguration speichern"
    },
    "leave_contacts_for_quote": {
        "ru": "Укажите контакты и мы пришлём расчёт",
        "en": "Leave your contact details and we’ll send you the quote",
        "de": "Hinterlassen Sie Ihre Kontaktdaten, und wir senden Ihnen das Angebot zu"
    },
    "perimeter_beam": {
        "ru": "Обвязка",
        "en": "Perimeter beam",
        "de": "Rahmenbalken"
    },
    "decorative_braces": {
        "ru": "Декоративные раскосы",
        "en": "Decorative braces",
        "de": "Dekorative Streben"
    },
    "left_rafters": {
        "ru": "Левые стропила",
        "en": "Left rafters",
        "de": "Linke Sparren"
    },
    "rafters": {
        "ru": "Стропила",
        "en": "Rafters",
        "de": "Sparren"
    },
    "right_rafters": {
        "ru": "Правые стропила",
        "en": "Right rafters",
        "de": "Rechte Sparren"
    },
    "battens": {
        "ru": "Обрешетка",
        "en": "Battens",
        "de": "Lattung"
    },
    "post": {
        "ru": "Столб",
        "en": "Post",
        "de": "Pfosten"
    },
    "posts": {
        "ru": "Столбы",
        "en": "Posts",
        "de": "Pfosten"
    },
    "ridge_beam": {
        "ru": "Конек",
        "en": "Ridge beam",
        "de": "Firstbalken"
    },
    "calculatePrice": {
        "ru": "Рассчитать стоимость",
        "en": "Calculate price",
        "de": "Preis berechnen"
    },
    "parameter": {
        "ru": "Параметры",
        "en": "Parameters",
        "de": "Parameter"
    }
}

